<app-carousel
  [hidePageIndicator]="true"
  [hideControls]="banners.length === 0"
  [hideArrowHighlights]="true"
  [autoScrollDelay]="10000"
  (visible)="handleSlideVisible($event)"
>
  @for (banner of banners; track banner) {
    <ng-template [appCarouselItem]="banner.id">
      <div [ngClass]="['slide-container', 'category-' + banner.category]">
        <div class="slide content">
          <div class="banner">
            <div
              class="banner-message"
              [innerHtml]="banner.content | markdown | async"
            ></div>
            @for (action of banner.actions; track action) {
              @if (action.type === "Link") {
                <a
                  mat-ripple
                  class="upgrade"
                  [href]="action.value"
                  [target]="'_blank'"
                  [innerText]="action.displayText"
                  (click)="handleBannerAction(banner, action)"
                >
                </a>
              }
              @if (action.type === "Reload") {
                <button
                  type="button"
                  mat-ripple
                  class="upgrade"
                  [innerText]="action.displayText"
                  (click)="handleBannerAction(banner, action)"
                ></button>
              }
            }
          </div>
          @if (banner.isDismissible) {
            <button
              type="button"
              class="close small-icon-button"
              mat-icon-button
              (click)="dismiss.emit(banner)"
            >
              <mat-icon>close</mat-icon>
            </button>
          }
        </div>
      </div>
    </ng-template>
  }
</app-carousel>
